/**
 * Stanowisko adresata
 *
 * @export
 * @enum {number}
 */
export enum RecipientPosition {
  PRESIDENT = 'PRESIDENT',
  MAYOR = 'MAYOR',
  COMMUNE_HEAD = 'COMMUNE_HEAD'
}

export const RecipientPositionTranslation = {
  [RecipientPosition.PRESIDENT]: 'Prezydent',
  [RecipientPosition.MAYOR]: 'Burmistrz',
  [RecipientPosition.COMMUNE_HEAD]: 'Wójt'
};

export const RecipientPositionList = [
  { value: RecipientPosition.PRESIDENT, text: RecipientPositionTranslation[RecipientPosition.PRESIDENT] },
  { value: RecipientPosition.MAYOR, text: RecipientPositionTranslation[RecipientPosition.MAYOR] },
  { value: RecipientPosition.COMMUNE_HEAD, text: RecipientPositionTranslation[RecipientPosition.COMMUNE_HEAD] }
];
